import React from 'react'
import { render } from "react-dom"
import App from './app.js'
import './scss/index.scss'

render(
    <App/>, document.getElementById("react-app")
)